// extracted by mini-css-extract-plugin
export default {"content":"ListUmkm_content__Ut-5h","main":"ListUmkm_main__S+aML","table-container":"ListUmkm_table-container__7ELZp","coba":"ListUmkm_coba__xAfKy"};